import { doRequest } from "utils/core";

const siteSettingsAPI = {
  getSiteSettings: () => {
    const url = "api/site_settings/info";
    return doRequest("get", url);
  },
};

export default siteSettingsAPI;
